// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {mdiArrowCollapseDown, mdiTableArrowUp} from '@mdi/js';

type Props = {
  ordersDispatch: any;
  data: object[];
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    props.ordersDispatch({...props.filtersValues, size: 10000});
  };
  const flattData = (data: any) => {
    const newData = data.map(el => {
      return {
        parcelItemId: el.id,
        productName: el.productName,
        productCode: el.productCode,
        variantId: el.skuId,
        variantCode: el.variantCode,
        count: el.count,
      };
    });
    return newData;
  };

  return (
    <>
      {props.data?.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="parcelVariants.csv"
          style={{
            padding: '7px',
            color: '#2F4858',
            marginLeft: '5px',
            textDecoration: 'none',
            border: '1px solid #2F4858',
            borderRadius: '5px',
            fontSize: '14px',
          }}
        >
          <Icon
            path={mdiArrowCollapseDown}
            size={'20px'}
            style={{paddingTop: '5px', paddingLeft: '3px'}}
          />
          EXCEL
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiTableArrowUp} size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
